import { healthResponseSchema } from "@pushup/shared";
import type { HealthResponse } from "@pushup/types";
import { api } from "@/lib/api";

export async function fetchHealth(): Promise<HealthResponse> {
  const data = await api.get<unknown>("/health");
  return healthResponseSchema.parse(data);
}
